import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Words } from 'pages'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getWordsFetch } from 'store/middlewares/words.crud'
import { useParams } from 'react-router-dom'
import { MarkingWordsAssessmentVM, WordVM } from 'models/VM'
import { useDispatch } from 'react-redux'
import { actions } from 'store'

const Assessment = () => {
    const { assessment } = useSelector(state => state.assessment)
    const params = useParams()
    const dispatch = useDispatch()

    const { assessment_def_visible_type, assessment_def_name, points } = assessment || {}

    const words = useQuery({
        queryKey: [qc.words],
        queryFn: async () => {
            let { data: nAssessment } = await getWordsFetch({ id: params.assessmentID })
            const mWords = []
            nAssessment.words.forEach((word, index) => mWords.push(new WordVM({ assessment: nAssessment, ...word }, index)))
            nAssessment = new MarkingWordsAssessmentVM(nAssessment, nAssessment.words)
            // dispatch(actions.setWords(mWords))// not use
            dispatch(actions.updateAssessment(nAssessment))
            return mWords
        }
    })

    useEffect(() => {
        return (() => {
            words?.remove?.()
        })
    }, [])

    return (
        <Words
            headerActions={[]}
            type={assessment_def_visible_type}
            name={assessment_def_name}
            words={words.data || []}
            points={points}
            showErrorTypes={true}
            settings={{
                viewResults: true
            }}
        />
    )
}

export default Assessment